/* eslint-disable */
// This file generated by `npm run build:generate`, don't edit manually.

import { DlgParams as DlgParamsComplex, DlgUnpacked as DlgUnpackedComplex } from "./schema.js";
import { DelegationTag as Tag } from "./schema.js";
/**
 * @category delegation signature
 */
type DlgParamsAensWildcard1Type = Omit<DlgParamsComplex & {
    tag: Tag.AensWildcard;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category delegation signature
 */
export interface DlgParamsAensWildcard1 extends DlgParamsAensWildcard1Type {
}
/**
 * @category delegation signature
 */
type DlgUnpackedAensWildcard1Type = DlgUnpackedComplex & {
    tag: Tag.AensWildcard;
    version: 1;
};
/**
 * @category delegation signature
 */
export interface DlgUnpackedAensWildcard1 extends DlgUnpackedAensWildcard1Type {
}
/**
 * @category delegation signature
 */
type DlgParamsAensName1Type = Omit<DlgParamsComplex & {
    tag: Tag.AensName;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category delegation signature
 */
export interface DlgParamsAensName1 extends DlgParamsAensName1Type {
}
/**
 * @category delegation signature
 */
type DlgUnpackedAensName1Type = DlgUnpackedComplex & {
    tag: Tag.AensName;
    version: 1;
};
/**
 * @category delegation signature
 */
export interface DlgUnpackedAensName1 extends DlgUnpackedAensName1Type {
}
/**
 * @category delegation signature
 */
type DlgParamsAensPreclaim1Type = Omit<DlgParamsComplex & {
    tag: Tag.AensPreclaim;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category delegation signature
 */
export interface DlgParamsAensPreclaim1 extends DlgParamsAensPreclaim1Type {
}
/**
 * @category delegation signature
 */
type DlgUnpackedAensPreclaim1Type = DlgUnpackedComplex & {
    tag: Tag.AensPreclaim;
    version: 1;
};
/**
 * @category delegation signature
 */
export interface DlgUnpackedAensPreclaim1 extends DlgUnpackedAensPreclaim1Type {
}
/**
 * @category delegation signature
 */
type DlgParamsOracle1Type = Omit<DlgParamsComplex & {
    tag: Tag.Oracle;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category delegation signature
 */
export interface DlgParamsOracle1 extends DlgParamsOracle1Type {
}
/**
 * @category delegation signature
 */
type DlgUnpackedOracle1Type = DlgUnpackedComplex & {
    tag: Tag.Oracle;
    version: 1;
};
/**
 * @category delegation signature
 */
export interface DlgUnpackedOracle1 extends DlgUnpackedOracle1Type {
}
/**
 * @category delegation signature
 */
type DlgParamsOracleResponse1Type = Omit<DlgParamsComplex & {
    tag: Tag.OracleResponse;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category delegation signature
 */
export interface DlgParamsOracleResponse1 extends DlgParamsOracleResponse1Type {
}
/**
 * @category delegation signature
 */
type DlgUnpackedOracleResponse1Type = DlgUnpackedComplex & {
    tag: Tag.OracleResponse;
    version: 1;
};
/**
 * @category delegation signature
 */
export interface DlgUnpackedOracleResponse1 extends DlgUnpackedOracleResponse1Type {
}
/**
 * @category delegation signature
 */
export type DlgParams = DlgParamsAensWildcard1 | DlgParamsAensName1 | DlgParamsAensPreclaim1 | DlgParamsOracle1 | DlgParamsOracleResponse1;
/**
 * @category delegation signature
 */
export type DlgUnpacked = DlgUnpackedAensWildcard1 | DlgUnpackedAensName1 | DlgUnpackedAensPreclaim1 | DlgUnpackedOracle1 | DlgUnpackedOracleResponse1;
